/////////////////////////////////////////////////////////////////////////////////////////////
// Copyright 2026 Garmin International, Inc.
// Licensed under the Flexible and Interoperable Data Transfer (FIT) Protocol License; you
// may not use this file except in compliance with the Flexible and Interoperable Data
// Transfer (FIT) Protocol License.
/////////////////////////////////////////////////////////////////////////////////////////////
// ****WARNING****  This file is auto-generated!  Do NOT edit this file.
// Profile Version = 21.218.0Release
// Tag = production/release/21.218.0-0-g96fee6d7
/////////////////////////////////////////////////////////////////////////////////////////////

package com.garmin.fit.types

/**
 * FIT profile type `fit_base_type`.
 */
public enum class FitBaseType(
    public val value: UByte,
) {
    ENUM(0u),
    SINT8(1u),
    UINT8(2u),
    SINT16(131u),
    UINT16(132u),
    SINT32(133u),
    UINT32(134u),
    STRING(7u),
    FLOAT32(136u),
    FLOAT64(137u),
    UINT8Z(10u),
    UINT16Z(139u),
    UINT32Z(140u),
    BYTE(13u),
    SINT64(142u),
    UINT64(143u),
    UINT64Z(144u),

    /** Returned for any raw value not present in the profile. */
    INVALID(UByte.MAX_VALUE),
    ;

    public companion object {
        private val byValue: Map<UByte, FitBaseType> =
            entries.associateBy { it.value }

        /** Maps a raw FIT value onto its enum entry, falling back to [INVALID]. */
        public fun fromValue(value: UByte): FitBaseType =
            byValue[value] ?: INVALID
    }
}
